import { render, staticRenderFns } from "./CompanyInfoView.vue?vue&type=template&id=79a0d199&scoped=true"
import script from "./CompanyInfoView.vue?vue&type=script&lang=ts"
export * from "./CompanyInfoView.vue?vue&type=script&lang=ts"
import style0 from "./CompanyInfoView.vue?vue&type=style&index=0&id=79a0d199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0d199",
  null
  
)

export default component.exports